<div [formGroup]="form">
    <div class="percent_value">
        <div class="row">
            <div class="col-xl-4 col-lg-5 col-5">
                <mat-label class="card-title text-dark mt-4 mb-4 font-14 font-400" style="line-height: 18px" i18n>Percentage Cover</mat-label>
            </div>
            <div class="col-xl-8 col-lg-7 col-7">
                <div class="example-label-container" [class]="vertical ? 'example-label-vertical' : 'example-label-horizontal'">
                    <label class="example-value-label slider-value font-14 value-cureent">{{ value }} %</label>
                </div>
            </div>
        </div>
    </div>
    <ngx-slider [(value)]="value" [options]="options" formControlName="percentageCover" [class.disable-div]="enable"></ngx-slider>
    <br />
</div>
